export default __webpack_public_path__ + "static/media/icon-linkedin.4febec6c.svg";